import React, {Component} from 'react'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import PropTypes from 'prop-types'

class DeleteModal extends Component {
    render() {
        const {barcodeNumber, isOpen, onOpen, onClose, onDelete, loading, error, id} = this.props

        return (
            <div className='DeleteModal'>
                <Modal isOpen={isOpen} toggle={onOpen}>
                    <ModalHeader toggle={onClose}>Xóa request generate lại label</ModalHeader>
                    <ModalBody>
                        <p className='font-size-lg'>
                            Xác nhận xóa request generate lại label của order <strong>#{barcodeNumber}?</strong>
                        </p>
                    </ModalBody>
                    <ModalFooter className='d-flex align-items-center justify-content-between'>
                        <Button color="secondary" onClick={onClose}>
                            Hủy
                        </Button>
                        {error && <div className='text-danger'>{error}</div>}
                        <Button color="danger" onClick={() => onDelete(id)}>
                            {loading === 'delete' && <i className='fa fa-spinner fa-spin mr-1'/>}
                            Xóa
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

DeleteModal.propTypes = {
    barcodeNumber: PropTypes.number,
    isOpen: PropTypes.bool,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    error: PropTypes.string,
    id: PropTypes.string
}

export default DeleteModal